import { actionCreator } from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';
import type { ComponentPreviewState } from '../miniOverview/types';

export const loadComponentPreview = actionCreator<{ componentId: ArdoqId }>(
  '[componentPreviews] LOAD_COMPONENT_PREVIEW'
);

export const componentPreviewLoaded = actionCreator<{
  componentId: ArdoqId;
  state: ComponentPreviewState;
}>('[componentPreviews] COMPONENT_PREVIEW_LOADED');
